import { Icon, type IconName } from "../icons/Icon";
import { formatRelative } from "../utils/format";

/** The ticket page and marks round (2026-10-23): a change to the ticket (an assignment, a status, a snooze, the AI taking or giving back a
 *  ticket) as one thin muted line in the thread, at its own time among the messages. Never a card, never the AI's hue: who did it is in words
 *  ("by Kriesi's AI"), the app and the model it reported are the hover. */
export interface ThreadEvent { id: string; what: string; /** who did it, in words: "Kriesi", "Kriesi's AI", "forum.kriesi.at" */ by: string; at: string; /** the hover on "by …": the AI's app and model */ title?: string; /** the line's small icon; the history icon when absent */ icon?: IconName }

/** one item of the thread's column: a message (`entry`) or a change (`event`), by its id */
export type ThreadItem = { kind: "entry" | "event"; id: string };
const ms = (iso: string) => Date.parse(iso);
/** Messages and events in one column, by time; at the same moment the message first and its events after it, each kind in its own order
 *  (a reply and the claim it made share one instant). Both lists come oldest first. Pure. */
export function threadWithEvents(entries: readonly { id: string; createdAt: string }[], events: readonly { id: string; at: string }[]): ThreadItem[] {
  const out: ThreadItem[] = [];
  let e = 0, v = 0;
  while (e < entries.length || v < events.length) {
    const takeEvent = e >= entries.length || (v < events.length && ms(events[v]!.at) < ms(entries[e]!.createdAt));
    out.push(takeEvent ? { kind: "event", id: events[v++]!.id } : { kind: "entry", id: entries[e++]!.id });
  }
  return out;
}

/** Several changes in a row stack as one quiet group between two messages. */
export function ThreadEventLines({ events, now = Date.now() }: { events: readonly ThreadEvent[]; now?: number }) {
  return (
    <ol className="ob-events">
      {events.map((l) => (
        <li key={l.id} className="ob-event">
          <Icon name={l.icon ?? "history"} size="xs" />
          <span className="ob-event__text"><span>{l.what}</span> <span className="ob-event__by" title={l.title}>by {l.by}</span></span>
          <span className="ob-event__time">· <time dateTime={l.at}>{formatRelative(l.at, now)}</time></span>
        </li>
      ))}
    </ol>
  );
}
